// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '',
          name: 'home',
          hash: 'PartyUp',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: '/:id',
          name: 'party',
          hash: 'PartyUp',
          component: () => import('@/views/home/Index.vue'),
          meta: { src: require('@/assets/article.jpg') },
        },
      ],
    },

  ],
})

export default router
